import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Backdrop,
  CircularProgress,
  Snackbar,
} from "@mui/material";
import MenuDrawer from "../../../components/MenuDrawer";
import AppBar from "../../../components/AppBar";
import { useNavigate } from "react-router-dom";
import { colors } from "./../../../theme/theme";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import TitleWithSearchBar from "./../../../components/TitleWithSearchBar";
import { StyledDataGrid } from "../../../components/StyledSearchDataGrid";
import axiosInstance, { BASE_URL } from "../../../constants/config";
import { useSelector } from "react-redux";
import { Close } from "@mui/icons-material";
import { RedModal } from "../../../components/ConfirmationModal";
import InactiveSwitch from "../../../components/InactiveSwitch";

const ActivityProvider = () => {
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const activitiesColumn = [
    {
      field: "S.No",
      headerName: "S.No",
      flex: 0.5,
      renderHeader: (params) => (
        <Typography
          sx={{
            fontSize: 14,
            fontWeight: "400",
            color: colors.text,
          }}
        >
          {params?.colDef?.headerName}
        </Typography>
      ),
      renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1,
    },
    {
      field: "name",
      headerName: "Name",
      flex: 2,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "400",
              color: colors.text,
              fontFamily: "FiraSans",
              ml: 1,
              whiteSpace: "pre-wrap",
              wordWrap: "break-word",
            }}
          >
            {params?.value}
          </Typography>
        </Box>
      ),
    },
    {
      field: "type",
      headerName: "Activity Type",
      flex: 1.5,
      renderCell: (params) => (
        <div
          style={{
            marginLeft: 10,
            fontWeight: "400",
            fontSize: "14px",
            color: "#596066",
          }}
        >
          {params?.value}
        </div>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => (
        <div
          style={{
            fontWeight: "400",
            fontSize: "14px",
            color: "#596066",
          }}
        >
          {params?.value?.charAt(0).toUpperCase() + params?.value?.slice(1)}
        </div>
      ),
    },
    {
      field: "actions",
      headerName: "",
      flex: 0.5,
      align: "center",
      renderCell: (params) => (
        <>
          <IconButton
            onClick={(e) => {
              handleClick(e);
              setactivityId(params.row?.id);
              setactivityStatus(params.row?.status);
              setactivityType(params.row?.type);
              setactivityIsAssigned(params?.row?.isAssigned);
            }}
          >
            <MoreVertIcon sx={{ height: "20px", width: "20px" }} />
          </IconButton>
        </>
      ),
    },
  ];

  const [loading, setloading] = useState(false);
  const [allActivities, setallActivities] = useState([]);

  const { userData } = useSelector((state) => state.user);

  const GetAllActivities = async () => {
    setloading(true);
    await axiosInstance
      .get(
        `${BASE_URL}/activity/getAllActivityByCustomerId?customerId=${userData?.customerId}`,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        setloading(false);
        setallActivities(res.data?.allFormsAndActivities);
      })
      .catch((e) => {
        setloading(false);
      });
  };

  useEffect(() => {
    GetAllActivities();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [search, setsearch] = useState("");
  const [deleteModalState, setdeleteModalState] = useState(false);
  const [deleteConfirmation, setdeleteConfirmation] = useState(false);
  const [activityType, setactivityType] = useState("");

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setdeleteConfirmation(false);
  };

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleSnackbarClose}
      >
        <Close fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  const [activityId, setactivityId] = useState("");
  const [status, setstatus] = useState("");
  const [activityStatus, setactivityStatus] = useState("");
  const [activityIsAssigned, setactivityIsAssigned] = useState();

  const UpdateActivityStatus = async () => {
    setloading(true);
    await axiosInstance
      .post(
        `${BASE_URL}/activity/updateActivityStatus`,
        {
          status: status,
          activityId: activityId,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        setloading(false);
        setdeleteConfirmation(true);
        GetAllActivities();
      })
      .catch((err) => {
        setloading(false);
      });
  };

  const UpdateFormStatus = async () => {
    setloading(true);
    await axiosInstance
      .post(
        `${BASE_URL}/form/updateFormStatus`,
        {
          status: status,
          formId: activityId,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        setloading(false);
        setdeleteConfirmation(true);
        GetAllActivities();
      })
      .catch((err) => {
        setloading(false);
      });
  };

  const [activeSwitch, setactiveSwitch] = useState(true);

  const handleactiveSwitch = () => {
    setactiveSwitch(!activeSwitch);
  };

  const filteredActivities = allActivities?.filter((val) => {
    return val?.status === (activeSwitch ? "active" : "inactive");
  });

  return (
    <Box style={{ backgroundColor: "#f7f8fa", display: "flex", flex: 1 }}>
      <MenuDrawer provider />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={deleteConfirmation}
        autoHideDuration={2000}
        onClose={handleSnackbarClose}
        message={"Activity status updated successfully"}
        action={action}
        sx={{
          "& .MuiSnackbarContent-root": {
            backgroundColor: "white",
            color: "black",
          },
        }}
      />
      <RedModal
        open={deleteModalState}
        onClose={() => setdeleteModalState(false)}
        onClick={
          activityType === "Form" ? UpdateFormStatus : UpdateActivityStatus
        }
        title="Confirmation"
        mainText={
          status === "inactive"
            ? "Make activity inactive?"
            : "Make activity active?"
        }
        subText={"Are you sure you want to change the status of this activity?"}
        actionText={status === "inactive" ? "Make Inactive" : "Make Active"}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          overflow: "hidden",
        }}
      >
        <AppBar title="Activities" />

        {/* <FilterBox type="activity" /> */}
        <Grid container p={2}>
          <Grid item xs={12} mb={2}>
            <InactiveSwitch
              activeSwitch={activeSwitch}
              handleactiveSwitch={handleactiveSwitch}
              title={"Activities"}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <Box
              mb={2}
              sx={{
                backgroundColor: "#fff",
                borderRadius: "12px",
              }}
            >
              <TitleWithSearchBar
                title="Activities"
                onClick={() =>
                  navigate("/provider/activities/create", {
                    state: { provider: true },
                  })
                }
                search={search}
                setSearch={setsearch}
              />

              <StyledDataGrid
                rows={
                  filteredActivities?.filter((val) =>
                    val?.name
                      ?.toLocaleLowerCase()
                      .includes(search?.toLocaleLowerCase())
                  ) || []
                }
                getRowId={(row) => row?.uniqId}
                columns={activitiesColumn}
                initialState={{
                  pagination: {
                    paginationModel: { page: 0, pageSize: 10 },
                  },
                }}
                sx={{
                  borderRadius: "12px",
                  border: "none",
                  "& .MuiDataGrid-virtualScroller": {
                    minHeight: "70vh",
                  },
                }}
                pageSizeOptions={[
                  5,
                  10,
                  { value: filteredActivities?.length, label: "All" },
                ]}
              />
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                {!activityIsAssigned && (
                  <MenuItem
                    sx={{
                      borderBottom: "1px solid #EBEFF5",
                      color: "#24292E",
                      fontSize: "12px",
                      fontWeight: "400",
                      fontFamily: "FiraSans",
                    }}
                    onClick={() =>
                      navigate("/provider/activities/update", {
                        state: { id: activityId },
                      })
                    }
                  >
                    Edit Activity
                  </MenuItem>
                )}
                <MenuItem
                  sx={{
                    borderBottom: "1px solid #EBEFF5",
                    color: "#24292E",
                    fontSize: "12px",
                    fontWeight: "400",
                    fontFamily: "FiraSans",
                  }}
                  onClick={() =>
                    navigate(`/provider/forms/form-details`, {
                      state: { id: activityId, type: activityType },
                    })
                  }
                >
                  View {activityType}
                </MenuItem>

                <MenuItem
                  sx={{
                    borderBottom: "1px solid #EBEFF5",
                    color: "#24292E",
                    fontSize: "12px",
                    fontWeight: "400",
                    fontFamily: "FiraSans",
                  }}
                  onClick={(e) => {
                    handleClose(e);
                    setdeleteModalState(true);
                    if (activityStatus === "active") {
                      setstatus("inactive");
                    } else {
                      setstatus("active");
                    }
                  }}
                >
                  Change Status as{" "}
                  {activityStatus === "active" ? "Inactive" : "Active"}
                </MenuItem>
              </Menu>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default ActivityProvider;
